import { trnInternal } from "./i18nStore";

export const trn = (
  key: string,
  defaultTranslation: string,
  replacements: Record<string, string | number> | null = null,
  instructions?: string
): string => trnInternal(key, defaultTranslation, replacements, instructions);

export const TRN = trn;
